import React from 'react';
import styles from './index.module.css';

interface SwitchButton {
  text: string;
  variant: 'base' | 'circ' | 'soft' | 'over' | 'sled' | 'bump';
  style?: React.CSSProperties;
  onClickButton?: () => void;
}

export const SwitchButton: React.FC<SwitchButton> = ({ text, variant, style, onClickButton }) => {
  const buttonClasses = [
    styles.button,
    styles[variant],
    variant === 'over' && styles.over,
    variant === 'sled' && styles.sled,
    variant === 'bump' && styles.bump
  ].filter(Boolean).join(' ');

  return (
    <button className={buttonClasses} style={style} onClick={onClickButton}>
      {text}
    </button>
  );
};

